import { C11nEnv } from '../interpreter/c11n-env';
import type { NodeProps } from '../contextree/types';

class AnnotationsHandler {
  private handlers: { [key: string]: (value: string, c11nEnv: C11nEnv, contextTreeNodeProps?: NodeProps) => unknown };
  constructor() {
    this.handlers = {};
  }

  registerHandler(name: string, handler: (value: string, c11nEnv: C11nEnv) => unknown) {
    this.handlers[name] = handler;
  }

  getHandler(name: string) {
    return this.handlers[name];
  }
}

export default new AnnotationsHandler();
